import { useEffect, useMemo, useState } from 'react';
import { loadPartyActivity } from '../../party-activity/partyActivity.service';
import { listSuppliersResult } from '../services/suppliers.service';
import { buildSupplierOverview } from '../utils/supplier.overview';

export default function useSupplierOverview(supplier, open) {
  const [snapshot, setSnapshot] = useState(null);
  const supplierId = supplier?.id;
  useEffect(() => {
    if (!open || !supplierId) return undefined;
    let current = true;
    setSnapshot(null);
    Promise.allSettled([loadPartyActivity(), listSuppliersResult()]).then(([activity, catalog]) => {
      if (!current) return;
      setSnapshot({
        id: supplierId,
        data: activity.status === 'fulfilled' ? activity.value.data : {},
        suppliers: catalog.status === 'fulfilled' && catalog.value.ok ? catalog.value.data : null,
      });
    });
    return () => { current = false; };
  }, [supplierId, open]);

  const ready = Boolean(snapshot && supplierId && snapshot.id === supplierId);
  const overview = useMemo(() => {
    if (!ready || !snapshot.suppliers || !supplier) return {};
    // Include the current card data while keeping the full catalog for unambiguous legacy names.
    const catalog = [...snapshot.suppliers.filter((row) => String(row.id) !== String(supplier.id)), supplier];
    return buildSupplierOverview(supplier, snapshot.data, catalog);
  }, [supplier, snapshot, ready]);
  return { overview, loading: Boolean(open && supplierId && !ready) };
}
